/**
 * Validate value is a number
 * 
 * @param {string} value
 * return {boolean}
 */
export function isValidNumber(value) {
    return /^[+]?([0-9]+\.?[0-9]*|\.[0-9]+)$/.test(value)
}